import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Action } from "shared/types/Action"
import { WithClassName } from "shared/types/WithClassName"

import { ProjectPageSidebarActions } from "pages/project-page/ui/ProjectPageSidebarActions"
import {
  MultiEditProductPositionForm,
  MultiEditProductPositionFormProps
} from "widgets/multi-edit-product-position-form/MultiEditProductPositionForm"

import "../../../styles/_project-page-sidebar.scss"

export interface ProductPositionMultiSelectSidebarViewModel
  extends WithClassName {
  selectedChildCount: number
  formProps: MultiEditProductPositionFormProps
  actions: Action[]
  autoFocus?: boolean
  hideControls?: boolean
}

export const ProductPositionMultiSelectSidebarView = React.memo(
  ({
    selectedChildCount,
    formProps,
    actions,
    autoFocus,
    hideControls,
    className
  }: ProductPositionMultiSelectSidebarViewModel) => {
    const { t } = useTranslation()
    return (
      <div
        className={classNames(
          "project-page-sidebar",
          "project-page-sidebar--product-position-multi",
          "card",
          "card--elevated",
          className
        )}
        data-testid="project-sidebar"
      >
        <div className="project-page-sidebar__content">
          <div className="project-page-sidebar__title" aria-live="polite">
            {selectedChildCount} {t("Project.SelectedProductPositions")}
          </div>
          <MultiEditProductPositionForm
            {...formProps}
            className="project-page-sidebar__form"
          />
        </div>
        {hideControls ? null : (
          <ProjectPageSidebarActions
            actions={actions}
            autoFocus={autoFocus}
            isIconOnly={formProps.isReadonly}
          />
        )}
      </div>
    )
  }
)
